import { render, staticRenderFns } from "./LsCopyContent.vue?vue&type=template&id=563554e7&scoped=true&"
import script from "./LsCopyContent.vue?vue&type=script&lang=js&"
export * from "./LsCopyContent.vue?vue&type=script&lang=js&"
import style0 from "./LsCopyContent.vue?vue&type=style&index=0&id=563554e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563554e7",
  null
  
)

export default component.exports